












import Vue from 'vue'
import { AntrfileImageElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AntrfileImageEl',

  props: {
    templateItemData: {
      type: Object as () => AntrfileImageElInterface,
      required: true
    }
  }
})
